import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41.03 51.42",
  class: "text-xs",
  fill: "currentColor"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("text", {
      class: "cls-1",
      transform: "translate(8.01 38.83)"
    }, [
      /*#__PURE__*/_createElementVNode("tspan", {
        x: "0",
        y: "0"
      }, " PDF ")
    ]),
    /*#__PURE__*/_createElementVNode("path", {
      class: "cls-2",
      d: "M.01,25.7c0-5.73-.02-11.46,0-17.2C.04,3.13,3.08,.08,8.44,.04,12.54,0,16.64,.1,20.73,\n            0c2.3-.05,4.15,.71,5.74,2.31,4.09,4.13,8.2,8.23,12.31,12.34,1.52,1.52,2.27,3.3,2.26,\n            5.51-.06,7.61,0,15.23-.03,22.84-.02,5.22-3.1,8.35-8.26,8.37-8.19,.04-16.39,.05-24.58,\n            0C3.15,51.35,.05,48.19,.02,43.15c-.04-5.82,0-11.64,0-17.45Zm5.13,.01c0,5.56-.01,11.13,\n            0,16.69,0,3.06,.75,3.84,3.72,3.84,7.77,.02,15.54,.02,23.32,0,2.87,0,3.69-.8,3.69-3.61,\n            .02-7.28-.02-14.55,.03-21.83,0-1.22-.37-2.08-1.22-2.92-3.84-3.78-7.65-7.59-11.41-11.44\n            -.91-.93-1.83-1.34-3.14-1.31-3.76,.08-7.52,.01-11.27,.03-2.96,.02-3.71,.79-3.72,3.85\n            -.01,5.56,0,11.13,0,16.69Z"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}